import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractService} from "../../../../../core/service/abstractService";
import {ProductDeliveredModel} from "../../../api/entity/productDelivered.model";

@Injectable()
export class ProductDeliveredService extends AbstractService<ProductDeliveredModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('ProductDelivered', serviceElementsFactory, injector);
    }

}
